module.exports = __webpack_public_path__ + "static/img/anonymity.3f9b695.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Ratings/anonymity.png
// module id = xJ96
// module chunks = 1